import { render, staticRenderFns } from "./list.vue?vue&type=template&id=2fa1c458&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa1c458",
  null
  
)

component.options.__file = "list.vue"
export default component.exports